import { Button } from './Button';

export { ButtonMenu } from './ButtonMenu';
export { ButtonLink } from './ButtonLink';
export { ButtonGroup } from './ButtonGroup';
export { SplitButton } from './SplitButton';
export { Button, Button as default };
export { buttonTheme } from './buttonTheme';

export * from './overrides';

console.warn('Stop using deprecated @cld/button. Use @clds/button instead.');
